import React from "react";
import {connect} from "react-redux";
import compose from "lodash/flowRight";
import Spinner from "shared/Experimental/General/components/Spinner/Spinner";
import {useLazyLogout} from "shared/Auth/hooks/useLogout";
import withAuth from "shared/Auth/withAuth/withAuth";
import {clearAuth} from "shared/Auth/actions/authActions";
import PageTitle from "shared/Shared/components/PageTitle/PageTitle";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import {AUTH_TRANSFER, IS_EMBEDDED} from "shared/Utils/Constants";
import {useTranslation} from "@unibuddy/intl";
import {getenv} from "../../../../src/util/getEnv";

export const LogoutComponent = ({dispatch, analytics}) => {
    const {t} = useTranslation(["common", "errorMessage"]);
    const {logout, isLoggedOut, error} = useLazyLogout();

    React.useEffect(() => {
        const HORSEA_URL = getenv("HORSEA_URL");
        if (IS_EMBEDDED) {
            window.parent.postMessage(
                {name: AUTH_TRANSFER, value: {token: false, me: false}},
                HORSEA_URL,
            );
        }
        logout();
        if (analytics) {
            analytics.unsetUser();
        }
        dispatch(clearAuth());
    }, [dispatch, analytics, logout]);

    let content = null;
    if (error) {
        content = <div>{t("errorMessage:genericError", "An error occured, please try again")}</div>;
    }
    if (isLoggedOut) {
        content = <p>{t("loggedOut", "You are now logged out")}</p>;
    }
    if (!content) {
        content = <Spinner />;
    }

    return (
        <>
            <PageTitle title="Logout" />
            {content}
        </>
    );
};

export default compose(withAuth, withAnalytics, connect())(LogoutComponent);
